<template>
  <el-container>
    <!-- 右侧容器 start -->
    <el-container class="indexBg pl-30" :style="homeStyle">
      <!-- 容器头 -->
      <el-header class="headerClass">
        <!-- 容器头组件 -->
        <frameHeader ref="header"></frameHeader>
      </el-header>
      <el-main>
        <!-- 个人信息展示 -->
        <el-row :gutter="20" class="header-gr">
          <!-- 左侧待办事项和通知公告 -->
          <el-col :xs="24" :sm="24" :md="24" :lg="7" :xl="5" class="">
            <el-row class="header-gr-left">
              <el-col :span="12">
                <div class="todoList dy-flex" @click="goRouter('/dbsx')">
                  <div class="align-i-c vertical-a-m">
                    <img src="/img/images/dbsx_icon.png" class="vertical-a-m" />
                  </div>
                  <div class="lh-36 vertical-a-m fs-14">待办事项</div>
                  <div class="lh-36 todo-num vertical-a-m">
                    {{ dbsxNum }}
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div
                  class="noticeList dy-flex align-i-c"
                  @click="goRouter('/tzgg')"
                >
                  <div class="align-i-c vertical-a-m">
                    <img src="/img/images/tzgg_icon.png" class="vertical-a-m" />
                  </div>
                  <div class="lh-36 vertical-a-m fs-14">通知公告</div>
                  <div class="lh-36 notice-num vertical-a-m">
                    {{ tzggNum }}
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <!-- 右侧个人信息展示 -->
          <el-col :xs="24" :sm="24" :md="24" :lg="17" :xl="19" class="">
            <el-row class="header-gr-rbg">
              <el-row class="header-gr-right dy-flex">
                <!-- 个人信息div排版 -->
                <div class="header-gr-rl dy-flex">
                  <div><img :src="userImg" class="head" /></div>
                  <div class="px-10">
                    <div>
                      <span class="name">{{ yhxx.ygmc }}</span>
                      <span class="pl-10">{{ yhxx.ygbh }}</span>
                    </div>
                    <div>
                      <span>{{ yhxx.gzbmmc }}</span>
                    </div>
                  </div>
                </div>
                <div class="header-gr-rc">
                  <div>
                    <span class="header-gr-rcs"
                      >电话：{{ yhxx.lxdh }}
                      <input
                        type="button"
                        class="xgTel"
                        value="修改"
                        @click="Change_tel()"
                    /></span>
                  </div>
                  <div>邮箱：{{ yhxx.email }}</div>
                </div>
                <div class="header-gr-rr dy-flex ml-auto">
                  <div class="pr-20">
                    <img src="/img/images/certificate_icon.png" />
                  </div>
                  <div class="pr-20">证件号</div>
                  <div>{{ yhxx.sfzh }}</div>
                </div>
              </el-row>
            </el-row>
          </el-col>
        </el-row>
        <!-- 首页 -->
        <div class="main dy-flex">
          <div class="mb-20 main-left mr-20 ht-all" :style="applicationStyle">
            <!-- <div class="main-left mr-20 ht-all"> -->
            <!-- 应用导航组件 -->
            <!-- <keep-alive> -->
            <application-navigation :width="900"> </application-navigation>
            <!-- </keep-alive> -->
            <!-- </div> -->
          </div>
          <!-- 银行卡和物流单据管理 -->
          <div class="pr-20 ml-auto">
            <!-- 银行卡管理 -->
            <div class="bg-color-w br-10 wt-300 py-10">
              <div class="px-20 pb-10">
                <span class="demonstration">
                  银行卡（{{ cardData.length }}）
                  <el-button type="text" @click="changeCard()"
                    ><span class="fs-14">修改<i class="el-icon-edit"></i></span
                  ></el-button>
                </span>
              </div>
              <div class="px-20">
                <el-carousel
                  trigger="click"
                  height="80px"
                  indicator-position="outside"
                  :autoplay="false"
                  class=""
                >
                  <el-carousel-item
                    v-for="(item, index) in cardData"
                    :key="index"
                    class=""
                  >
                    <div class="dy-flex pt-10 pl-10">
                      <div>
                        <img
                          :src="
                            item.cardName === '农业银行'
                              ? nyCard
                              : item.cardName === '中国银行'
                              ? zgCard
                              : item.cardName === '交通银行'
                              ? jtCard
                              : item.cardName === '建设银行'
                              ? jsCard
                              : item.cardName === '工商银行'
                              ? gsCard
                              : ''
                          "
                          width="21px"
                          height="21px"
                        />
                      </div>
                      <div class="color-w pl-10">
                        {{ item.cardName ? item.cardName : "" }}
                      </div>
                    </div>
                    <div class="color-w mt-10 fw-7 fs-20 pl-40">
                      {{ item.cardNum }}
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <!-- 物流数据管理 -->
            <div class="bg-color-w br-10 mt-20 wt-300 py-20">
              <div class="dy-flex px-20">
                <div>单据物流跟踪</div>
                <div class="ml-auto">
                  <el-button
                    type="text"
                    class="fs-16 pa-0 pt-3"
                    @click="goto('/wldjgz')"
                    >查看更多></el-button
                  >
                </div>
              </div>
              <div class="px-20">
                <template v-for="item in 3">
                  <div
                    class="bw-b-1 br-b-solid br-color-info pt-20 ht-28"
                    :key="item"
                  >
                    <el-button
                      v-if="wlList.length > 0"
                      type="text"
                      @click="goto('/wldjgz', wlList[item - 1].lsh)"
                      class="py-5 fs-16 ml-10 text-l-b fw-7"
                    >
                      {{ wlList[item - 1].model }}
                      {{ setNum(wlList[item - 1].lsh, 0, 4, 4) }}
                      {{ wlList[item - 1].clzt }}
                    </el-button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
    <!-- 模态框修改联系方式用-->
    <el-dialog
      title="修改联系方式"
      :visible.sync="dialogxglxfs"
      width="450px"
      class="dialog-lxfs"
    >
      <el-form :model="xglxfsForm">
        <el-form-item label="电话：" label-width="100px">
          <el-input
            v-model="xglxfsForm.mobie"
            autocomplete="off"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" label-width="100px">
          <el-input
            v-model="xglxfsForm.email"
            autocomplete="off"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码：" label-width="100px">
          <el-input
            v-model="xglxfsForm.yzm"
            autocomplete="off"
            class="yzm"
            size="small"
          ></el-input>
          <el-button
            class="hqyzm"
            type="primary"
            size="small"
            @click="hqyzm(xglxfsForm.mobie)"
            v-if="acquire"
          >
            <span>获取验证码</span>
          </el-button>
          <el-button
            class="hqyzm"
            type="primary"
            size="small"
            plain
            disabled
            v-else
          >
            <span>{{ "(" + second + ")秒后重新获取" }}</span>
          </el-button>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            type="primary"
            @click="
              lxfsCommit(xglxfsForm.mobie, xglxfsForm.email, xglxfsForm.yzm)
            "
            size="small"
          >
            <i class="fa fa-check" /> 确 定</el-button
          >
          <el-button @click="dialogxglxfs = false" size="small">
            <i class="fa fa-close" /> 取 消</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 模态框修改银行卡号用-->
    <el-dialog
      title="修改银行卡号"
      :visible.sync="dialogxgyhzh"
      width="1300px"
      class="dialog-lxfs"
    >
      <el-row class="mx-20">
        <!-- 工资卡 -->
        <el-row class="mb-20">
          <el-row>
            <p class="fs-18 color-b fw-7">{{ gzzh.cardName }}：</p>
            <el-row
              v-if="gzzh.sfqy_editcard_yhk == '1'"
              type="flex"
              class="mt-5"
            >
              <img src="/img/images/fonts/warning2.png" style="height:16px" />
              <span class="ml-5">{{ gzzh.sm_editcard_yhk }} </span>
            </el-row>
          </el-row>
          <el-row class="mt-10">
            <el-col :span="11">
              <el-input v-model="gzzh.cardNum" :disabled="true">
                <template #prepend
                  ><span class="color-b">原账号</span></template
                >
              </el-input>
            </el-col>
            <el-col :span="11">
              <el-input v-model="gzzh.khhmc" :disabled="true">
                <template #prepend
                  ><span class="color-b">原开户行</span></template
                >
              </el-input>
            </el-col>
          </el-row>
          <el-row class="mt-15">
            <el-col :span="11">
              <el-input v-model="gzzh.newNum">
                <template #prepend
                  ><span class="color-b">新账号</span></template
                >
              </el-input>
            </el-col>
            <el-col :span="11">
              <el-input v-model="gzzh.newYh" @focus="cxlhh(gzzh.index)">
                <template #prepend>
                  <span class="color-b">开户行</span>
                </template>
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="xgyhzhCommit(gzzh)"
                >提 交</el-button
              >
            </el-col>
          </el-row>
        </el-row>
        <!-- 普通卡 -->
        <template v-for="(item, index) in yhzhs">
          <el-row :key="index" class="my-20">
            <el-row>
              <p class="fs-18 color-b fw-7">{{ item.cardName }}：</p>
              <el-row
                v-if="item.sfqy_editcard_yhk == '1'"
                type="flex"
                class="mt-5"
              >
                <img src="/img/images/fonts/warning2.png" style="height:16px" />
                <span class="ml-5">{{ item.sm_editcard_yhk }} </span>
              </el-row>
            </el-row>
            <el-row class="mt-10">
              <el-col :span="11">
                <el-input v-model="item.cardNum" :disabled="true">
                  <template #prepend
                    ><span class="color-b">原账号</span></template
                  >
                </el-input>
              </el-col>
              <el-col :span="11">
                <el-input v-model="item.khhmc" :disabled="true">
                  <template #prepend
                    ><span class="color-b">原开户行</span></template
                  >
                </el-input>
              </el-col>
              <el-col :span="2">
                <el-button type="danger" @click="delCard(item.cardNum)"
                  >删 除</el-button
                >
              </el-col>
            </el-row>
            <el-row class="mt-15">
              <el-col :span="11">
                <el-input v-model="item.newNum">
                  <template #prepend
                    ><span class="color-b">新账号</span></template
                  >
                </el-input>
              </el-col>
              <el-col :span="11">
                <el-input v-model="item.newYh" @focus="cxlhh(item.index)">
                  <template #prepend>
                    <span class="color-b">开户行</span>
                  </template>
                </el-input>
              </el-col>
              <el-col :span="2">
                <el-button type="primary" @click="xgyhzhCommit(item)"
                  >提 交</el-button
                >
              </el-col>
            </el-row>
          </el-row>
        </template>
        <!-- 公务卡 -->
        <el-row class="my-20">
          <el-row>
            <p class="fs-18 color-b fw-7">公务卡：</p>
            <el-row
              v-if="gwkh.sfqy_editcard_yhk == '1'"
              type="flex"
              class="mt-5"
            >
              <img src="/img/images/fonts/warning2.png" style="height:16px" />
              <span class="ml-5">{{ gwkh.sm_editcard_yhk }} </span>
            </el-row>
          </el-row>
          <el-row class="mt-10">
            <el-col :span="11">
              <el-input v-model="gwkh.cardNum" :disabled="true">
                <template #prepend
                  ><span class="color-b">原账号</span></template
                >
              </el-input>
            </el-col>
            <el-col :span="11">
              <el-input v-model="gwkh.newNum">
                <template #prepend
                  ><span class="color-b">新账号</span></template
                >
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="xgyhzhCommit(gwkh)"
                >提 交</el-button
              >
            </el-col>
          </el-row>
        </el-row>
      </el-row>
      <!-- 查询开户行 -->
      <el-dialog
        width="50%"
        title="查询开户行"
        :visible.sync="dialogcxlhh"
        append-to-body
      >
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-input
              v-model="lhhstring"
              placeholder="检索关键词具体到支行名称，多个关键词请用空格隔开如(中国 天津)"
            ></el-input>
          </el-col>
          <el-col :span="4" class="ml-20">
            <el-button type="primary" plain @click="getLhh()">查询</el-button>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" class="color-danger text-a-c">
          <el-col :span="20" class="mt-10">
            *检索关键词具体到支行名称，多个关键词请用空格隔开如(中国 天津)
          </el-col>
          <el-col :span="4"> </el-col>
        </el-row>
        <el-row class="mt-20">
          <el-row>
            <!-- 动态表格组件 -->
            <TableCommon
              v-loading="tabLoading"
              :element-loading-text="$t('elTable.loadingText')"
              element-loading-spinner="el-icon-loading"
              :tableColumns="tableColumns"
              :tableData="lhhList"
              :currentPage="currentPage"
              :limit="limit"
              :uniqueNum="uniqueNum"
              @rowclick="rowclick"
              :height="450"
            ></TableCommon>
          </el-row>
          <el-row>
            <!-- 分页组件 -->
            <Pagination
              :currentPage="currentPage"
              :total="total"
              :limit="limit"
              :small="true"
              :pageSizes="$store.state.pageSizes"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
              :uniqueNum="uniqueNum"
            />
          </el-row>
        </el-row>
      </el-dialog>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogxgyhzh = false" size="small">
            <i class="fa fa-close" /> 取 消</el-button
          >
        </span>
      </template>
    </el-dialog>
  </el-container>
</template>

<script>
import frameHeader from "@/layout/frameHeader.vue";
// 导航页
import ApplicationNavigation from "@/components/ApplicationNavigation.vue";
import * as yhxx from "@/api/yhxx";
import * as wldj from "@/api/wldj";
import * as SysCommon from "@/api/sysCommon";

export default {
  name: "home",
  components: {
    frameHeader,
    ApplicationNavigation,
  },
  computed: {
    homeStyle() {
      return {
        width: this.$store.state.screenWidth - 230 + "px",
      };
    },
    applicationStyle() {
      return {
        width: this.$store.state.screenWidth - 580 + "px",
      };
    },
    // 用户信息
    yhxx() {
      let user = this.$store.state.userInfo;
      let xx = this.$store.state.yhxx.yhxx;
      if (xx && xx.ygmc != "" && xx.ygbh != "") {
        return this.$store.state.yhxx.yhxx;
      } else if (this.$store.state.userInfo) {
        this.userInfo.ygmc = user[0].yhmc;
        this.userInfo.ygbh = user[0].yhbh;
        this.userInfo.lxdh = user[0].tel;
        this.userInfo.email = user[0].email;
        this.$store.commit("yhxx/setYhxx", this.userInfo);
      }
      return this.userInfo;
    },
    // 银行卡信息
    cardData() {
      const card = this.setYhCard(this.$store.state.yhxx.yhxx, 0);
      return card;
    },
    // 用户头像
    userImg() {
      return this.$store.state.yhxx.phtot;
    },
    // 通知公告数量
    tzggNum() {
      return this.$store.state.yhxx.tzggNum;
    },
    // 待办事项数量
    dbsxNum() {
      return this.$store.state.yhxx.dbsxNum;
    },
  },
  watch: {},
  data() {
    return {
      nyCard: "/img/images/ABC.png", // 农业银行logo
      jsCard: "/img/images/CBC.png", // 建设银行logo
      jtCard: "/img/images/HSBC.png", // 交通银行logo
      gsCard: "/img/images/ICBC.png", // 工商银行logo
      zgCard: "/img/images/ABC.png", // 中国银行logo
      screenWidth: "", // 窗口宽度
      screenHeight: "", // 窗口高度
      dialogxglxfs: false, // 控制修改联系方式模态框
      dialogxgyhzh: false, // 控制修改银行账户模态框
      dialogcxlhh: false, // 控制查询开户行弹出框
      xglxfsForm: {
        // 修改联系方式数据
        mobie: "",
        email: "",
      },
      lhhstring: null, // 开户行名称
      sfzh: "", // 身份证号
      tabLoading: false, // 控制查询开户行刷新显示
      currentPage: 1, // 当前页
      limit: this.$store.state.dataDisplayNum, // 每页数据量
      uniqueNum: "Y116101-1-1", // 页面唯一标识（用于区分同一页面多个模块多个分组情况）
      total: 0, // 数据量
      cards: [], // 银行卡数据
      userInfo: {}, // 用户信息
      yhzhs: [], // 银行账户
      gwkh: {}, // 公务卡号
      gzzh: {}, // 工资卡号
      lhhList: [], // 开户行集合
      lhh: [], // 选择的开户行
      wlList: [], // 物流数据
      tableColumns: [], // 表格表头
      cardInfo: {}, // 银行卡信息
      activeInput: -2, // 记录点击的是第几个银行卡
      second: 60, // 获取验证码时倒计时
      acquire: true, // 控制获取验证码按钮是否可点击
    };
  },
  methods: {
    // 编号加密
    setNum(num, start, middle, end) {
      let xx = "*******************************";
      let str = "";
      str = str + num.substring(0, start);
      str = str + xx.substring(0, middle);
      str = str + num.substring(num.length - end);
      return str;
    },
    // 获取用户信息
    getyhxx() {
      yhxx.getYhxx().then((res1) => {
        this.$store.commit("yhxx/setYhxx", res1.data.data);
      });
    },
    // 修改银行卡信息
    setYhCard(yhxx, i) {
      const cards = [];
      if (yhxx.yhzh != "") {
        const card = {
          newNum: "",
          newYh: "",
          newYhCode: "",
          cardName: yhxx.yhmc,
          cardNum: yhxx.yhzh,
          khhmc: yhxx.khhmc,
          yh: yhxx.yh,
          sfqy_editcard_yhk: this.cardInfo.sfqy_editcard_gzk,
          sm_editcard_yhk: this.cardInfo.sm_editcard_gzk,
          index: 0,
        };
        if (i == 0) {
          cards.push(card);
        } else {
          this.gzzh = card;
        }
      }
      if (yhxx.yhzh1 != "") {
        const card1 = {
          newNum: "",
          newYh: "",
          newYhCode: "",
          cardName: yhxx.yhmc1,
          cardNum: yhxx.yhzh1,
          khhmc: yhxx.khhmc1,
          yh: yhxx.yh1,
          sfqy_editcard_yhk: this.cardInfo.sfqy_editcard_yhk1,
          sm_editcard_yhk: this.cardInfo.sm_editcard_yhk1,
          index: 1,
        };
        cards.push(card1);
      }
      if (yhxx.yhzh2 != "") {
        const card2 = {
          newNum: "",
          newYh: "",
          newYhCode: "",
          cardName: yhxx.yhmc2,
          cardNum: yhxx.yhzh2,
          khhmc: yhxx.khhmc2,
          yh: yhxx.yh2,
          sfqy_editcard_yhk: this.cardInfo.sfqy_editcard_yhk2,
          sm_editcard_yhk: this.cardInfo.sm_editcard_yhk2,
          index: 2,
        };
        cards.push(card2);
      }
      if (yhxx.yhmc3 != "" && yhxx.yhzh3 != "") {
        const card3 = {
          newNum: "",
          newYh: "",
          newYhCode: "",
          cardName: yhxx.yhmc3,
          cardNum: yhxx.yhzh3,
          khhmc: yhxx.khhmc3,
          yh: yhxx.yh3,
          sfqy_editcard_yhk: this.cardInfo.sfqy_editcard_yhk3,
          sm_editcard_yhk: this.cardInfo.sm_editcard_yhk3,
          index: 3,
        };
        cards.push(card3);
      }
      if (yhxx.yhmc4 != "" && yhxx.yhzh4 != "") {
        const card4 = {
          newNum: "",
          newYh: "",
          newYhCode: "",
          cardName: yhxx.yhmc4,
          cardNum: yhxx.yhzh4,
          khhmc: yhxx.khhmc4,
          yh: yhxx.yh4,
          sfqy_editcard_yhk: this.cardInfo.sfqy_editcard_yhk4,
          sm_editcard_yhk: this.cardInfo.sm_editcard_yhk4,
          index: 5,
        };
        cards.push(card4);
      }
      if (yhxx.yhmc5 != "" && yhxx.yhzh5 != "") {
        const card5 = {
          newNum: "",
          newYh: "",
          newYhCode: "",
          cardName: yhxx.yhmc5,
          cardNum: yhxx.yhzh5,
          khhmc: yhxx.khhmc5,
          yh: yhxx.yh5,
          sfqy_editcard_yhk: this.cardInfo.sfqy_editcard_yhk5,
          sm_editcard_yhk: this.cardInfo.sm_editcard_yhk5,
          index: 5,
        };
        cards.push(card5);
      }
      if (yhxx.gwkh != "") {
        const card6 = {
          cardName: "公务卡",
          cardNum: yhxx.gwkh,
          sfqy_editcard_yhk: this.cardInfo.sfqy_editcard_gwk,
          sm_editcard_yhk: this.cardInfo.sm_editcard_gwk,
          index: 6,
        };
        if (i == 0) {
          cards.push(card6);
        } else {
          this.gwkh = card6;
        }
      }
      return cards;
    },
    // 显示修改联系方式模态框
    Change_tel() {
      // this.xglxfsForm.mobie = this.yhxx.lxdh;
      // this.xglxfsForm.email = this.yhxx.email;
      // this.dialogxglxfs = true;
      this.$router.push({
        name: "/personalCenter",
        params: {
          activeMenu: "1",
        },
      });
    },
    // 显示修改银行卡号模态框
    changeCard() {
      // this.getPageTableConfig();
      // this.dialogxgyhzh = true;
      this.$router.push({
        name: "/personalCenter",
        params: {
          activeMenu: "3",
        },
      });
    },
    // 修改联系方式提交
    lxfsCommit(mobie, email, yzm) {
      if (yzm && yzm !== "") {
        let param = {};
        param.mobie = mobie;
        param.email = email;
        param.yzm = yzm;
        yhxx.updateLxfs(param).then((res) => {
          if (res.data.code === 200) {
            this.xglxfsForm.yzm = "";
            this.second = 0;
            this.yhxx.lxdh = mobie;
            this.yhxx.email = email;
            this.$store.commit("yhxx/setYhxx", this.yhxx);
            this.$message({
              message: res.data.message,
              type: "success",
            });
          } else if (res.data.code === 500) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        });
        this.dialogxglxfs = false;
      } else {
        this.$confirm(
          "<span class='fs-16 fw-600'>"+this.$t('common.qxsryzm')+"</span>",
            this.$t('common.tips'),
            {
              confirmButtonText: this.$t('common.confirmBtn'),
            type: "warning",
            center: true,
            showCancelButton: false,
            dangerouslyUseHTMLString: true,
          }
        );
      }
    },
    // 修改银行账户提交
    xgyhzhCommit(item) {
      let index = item.index;
      const yhmc = item.newYh.substring(2, 6);
      const param = {
        ygmc: this.yhxx.ygmc,
        roleId: this.yhxx.roleId,
        oldyhzh: item.cardNum,
      };
      switch (index) {
        case 0:
          param.yhzh = item.newNum;
          param.Khhmc = item.newYh;
          param.lhh = item.newYhCode;
          param.yhmc = yhmc;
          param.yh = "ABC";
          break;
        case 1:
          param.yhzh1 = item.newNum;
          param.Khhmc1 = item.newYh;
          param.lhh1 = item.newYhCode;
          param.yhmc1 = yhmc;
          break;
        case 2:
          param.yhzh2 = item.newNum;
          param.Khhmc2 = item.newYh;
          param.lhh2 = item.newYhCode;
          param.yhmc2 = yhmc;
          break;
        case 3:
          param.yhzh3 = item.newNum;
          param.Khhmc3 = item.newYh;
          param.lhh3 = item.newYhCode;
          param.yhmc3 = yhmc;
          break;
        case 4:
          param.yhzh4 = item.newNum;
          param.Khhmc4 = item.newYh;
          param.lhh4 = item.newYhCode;
          param.yhmc4 = yhmc;
          break;
        case 5:
          param.yhzh5 = item.newNum;
          param.Khhmc5 = item.newYh;
          param.lhh5 = item.newYhCode;
          param.yhmc5 = yhmc;
          break;
        case 6:
          param.gwkh = item.newNum;
          break;
      }
      yhxx.updataYhzh(param).then((res) => {
        this.getyhxx();
        this.getYhzhInfo();
        this.$message({
          message: "修改银行账户成功！",
          type: "success",
        });
      });
    },
    /** 页面跳转 */
    goto(route, Lsh) {
      this.$router.push({ path: route, query: { lsh: Lsh } });
    },
    /** 打开查询开户行弹窗 */
    cxlhh(index) {
      this.activeInput = index;
      this.dialogcxlhh = true;
    },
    /** 根据关键字获取开户行 */
    getLhh() {
      let s = [];
      let params = {};
      if (this.lhhstring != null && this.lhhstring != "") {
        s = this.lhhstring.split(" ");
      }
      params.yhName = s;
      params.currentPage = this.currentPage;
      params.limit = this.limit;
      yhxx.getLhhList(params).then((res) => {
        this.lhhList = res.data.data;
        this.total = this.lhhList[0].count;
      });
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.getLhh();
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.getLhh();
    },
    // 表格点击行事件
    rowclick(row, column, event) {
      if (this.activeInput == 0) {
        this.gzzh.newYh = row.yhName;
        this.gzzh.newYhCode = row.yhCode;
      } else if (this.activeInput == 6) {
        this.gwkh.newYh = row.yhName;
        this.gwkh.newYhCode = row.yhCode;
      } else {
        this.yhzhs.map((item) => {
          if (item.index == this.activeInput) {
            item.newYh = row.yhName;
            item.newYhCode = row.yhCode;
          }
        });
      }
      this.dialogcxlhh = false;
    },
    /** 获取页面表格配置信息 */
    getPageTableConfig() {
      let params = {};
      params.pageId = "Y116101";
      params.moduleId = "1";
      params.groupId = "1";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        this.tableColumns = tmpResult;
      });
    },
    /** 获取物流单据信息 */
    getLogisticsLsh() {
      wldj.getLogisticsLsh({ day: "3" }).then((res) => {
        if (res.data.code == "200") {
          let list = [];
          list = res.data.data;
          this.wlList = res.data.data;
          // list.map((item) => {
          //   this.wlList.push(item);
          // });
        }
        // else {
        //   this.$message.error(this.$t("resultCodeInfo." + res.data.code));
        // }
      });
    },
    /** 获取银行配置信息 */
    getYhzhInfo() {
      SysCommon.getEditCardInfo().then((res) => {
        this.cardInfo = res.data.data;
        // 获取银行卡基本信息
        yhxx.getYhzhInfo().then((res) => {
          if (res.data.code == "200") {
            this.yhzhs = this.setYhCard(res.data.data, 1);
          }
          // else {
          //   this.$message.error(this.$t("resultCodeInfo." + res.data.code));
          // }
        });
      });
    },
    /** 删除银行卡 */
    delCard(cardNum) {
      yhxx.delCard({ yhzhNum: cardNum }).then((res) => {});
    },
    // 获取验证码
    hqyzm(mobie) {
      if (mobie && mobie != "") {
        this.second = 60;
        this.acquire = false;
        yhxx.sendMessage({ mobie: mobie, type: "xglxfs" }).then((res) => {
          this.$message({
            message: res.data.data,
            type: "success",
          });
        });
        let con = setInterval(() => {
          this.second = this.second - 1;
          if (this.second <= 0) {
            this.acquire = true;
            clearInterval(con);
          }
        }, 1000); //延迟1000毫秒
      } else {
        this.$message({
          message: "手机号为空，请输入手机号再次获取验证码！",
          type: "error",
        });
      }
    },
    goRouter(path) {
      this.$router.push({ path: path }).catch((err) => {
        err;
      });
    },
  },
  created() {},
  mounted() {
    // this.getPageTableConfig();
    // 获取物流单据信息
    this.getLogisticsLsh();
    // 获取银行配置信息
    this.getYhzhInfo();
    // 监听浏览器的宽和高   用来计算公告显示宽度
    this.screenWidth = document.body.clientWidth;
    this.screenHeight = document.body.clientHeight;
    this.$store.commit("setScreenWidth", document.body.clientWidth);
    this.$store.commit("setScreenHeight", document.body.clientHeight);
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
        this.screenHeight = document.body.clientHeight;
        this.$store.commit("setScreenWidth", document.body.clientWidth);
        this.$store.commit("setScreenHeight", document.body.clientHeight);
      })();
    };
    // this.$requestUtil.getRouter().then((tmpResult) => {
    //   this.$comUtils.saveObjArr("menuRouter", tmpResult); // 存储路由到localStorage
    //   this.$root.$emit("menuRouter", tmpResult);
    // });
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dialogClass .el-dialog__body {
  // .el-dialog__body {
  padding-top: 10px;
  // }
}
.headerClass {
  height: 100px !important;
  // border-bottom: 1px solid rgba(220, 223, 230, 0.5);
  display: flex;
  // align-items: center;
  justify-items: center;
  padding: 0px;
  flex-shrink: inherit;
}
.content {
  width: auto;
  // padding: 10px;
  overflow: hidden;
  box-sizing: border-box;
}
.el-container {
  width: 100%;
  height: 100%;
  background-color: #f7f8f9;
}
.el-main {
  padding: 0;
}
.indexBg {
  background-image: url(/img/images/index_bg.png);
  background-position: right top;
  background-repeat: no-repeat;
  overflow-y: auto;
}
.header-gr {
  min-height: 80px;
  width: 100%;
  .header-gr-left {
    width: 100%;
    height: 80px;

    // line-height: 40px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0px 7px 12px 0px rgb(26 114 224 / 6%);
    display: flex;
    flex-direction: row;
    -webkit-flex-direction: row;
    justify-content: space-between;
    .todoList {
      background-image: url(/img/images/notice_bg.png);
      background-position: 90% 70%;
      background-repeat: no-repeat;
      margin-right: 5px;
      background-color: #f9f0e1;
      border-radius: 10px;
      padding: 10px 10px 10px 10px;
      flex: 1;
      cursor: pointer;
      flex-direction: row;
      -webkit-flex-direction: row;
      justify-content: space-between;
      .todo-num {
        color: #f89d08;
        font-size: 24px;
        font-weight: 700;
      }
    }
    .noticeList {
      background-image: url(/img/images/notice_bg.png);
      background-position: 90% 70%;
      background-repeat: no-repeat;
      margin-left: 5px;
      background-color: #e0eaf4;
      border-radius: 10px;
      padding: 10px 10px 10px 10px;
      flex: 1;
      cursor: pointer;
      flex-direction: row;
      -webkit-flex-direction: row;
      justify-content: space-between;
      .notice-num {
        color: #0067c0;
        font-size: 24px;
        font-weight: 700;
      }
    }
  }
  .header-gr-rbg {
    background-image: url(/img/images/userInfo_bg.png);
    background-repeat: repeat-x;
    border-radius: 10px;
  }
  .header-gr-right {
    width: 100%;
    height: 80px;
    border: 1px solid #9dbdd7;
    padding: 15px 12px;

    box-shadow: 0px 7px 12px 0px rgb(26 114 224 / 6%);
    background-image: url(/img/images/userBg.png);
    background-repeat: no-repeat;
    background-position: left top;
    border-radius: 10px;
    .head {
      width: 50px;
      height: 50px;
      border: 2px solid #ffffff;
      border-radius: 50%;
    }
    .header-gr-rl {
      line-height: 25px;
      .name {
        font-size: 16px;
        color: #0067c0;
      }
    }
    .header-gr-rc {
      padding-left: 20px;
      border-left: 1px solid #a7caf4;
      line-height: 25px;
    }
    .header-gr-rr {
      line-height: 25px;

      border-radius: 10px;
      background: -moz-linear-gradient(left, #cce5f6 0%, #d8e8f7 100%);
      background: -webkit-gradient(
        linear,
        left,
        right,
        color-stop(0%, #cce5f6),
        color-stop(100%, #d8e8f7)
      );
      background: -webkit-linear-gradient(
        0deg,
        rgb(204, 229, 246) 0%,
        rgb(216, 232, 247) 100%
      );
      background: -o-linear-gradient(
        -90deg,
        rgb(204, 229, 246) 0%,
        rgb(216, 232, 247) 100%
      );
      background: -ms-linear-gradient(
        -90deg,
        rgb(204, 229, 246) 0%,
        rgb(216, 232, 247) 100%
      );
      background: linear-gradient(to right, #cce5f6 0%, #d8e8f7 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#cce5f6', endColorstr='#d8e8f7',GradientType=0 );
      font-size: 18px;
      font-weight: 700;
      color: #0067c0;
      padding: 14px 15px 7px 10px;
    }
    .xgTel {
      width: 17px;
      height: 17px;
      display: none;
      border: none;
      margin-left: 10px;
      cursor: pointer;
      background-image: url(/img/images/xg_icon.png);
      background-repeat: no-repeat;
      text-indent: -9999px;
      outline: none;
    }
    .header-gr-rcs:hover .xgTel {
      display: inherit;
    }
  }
}
.dialog-lxfs {
  .el-input {
    width: 95%;
  }
  .yzm {
    width: 50%;
  }
  .hqyzm {
    margin-left: 10px;
  }
  .el-button--primary {
    background-color: #0d6ce4;
    border-color: #0d6ce4;
  }
}

.el-aside {
  overflow-x: hidden;
  // background-color: #8363b6;
  text-align: left;
}
[v-cloak] {
  display: none !important;
}
.main {
  margin-top: 20px;
  .main-left {
    background-color: #ffffff;
    box-shadow: 0px 7px 12px 0px rgb(26 114 224 / 6%);
    border-radius: 10px;
    .navigation {
      padding: 20px;
    }
  }
  .main-right {
    .main-right1 {
      background-color: #ffffff;
      box-shadow: 0px 7px 12px 0px rgb(26 114 224 / 6%);
      border: 1px solid #ffffff;
      border-radius: 10px;
      padding: 20px;
    }
    .main-right2 {
      background-color: #ffffff;
      box-shadow: 0px 7px 12px 0px rgb(26 114 224 / 6%);
      border: 1px solid #ffffff;
      border-radius: 10px;
      padding: 20px;
    }
  }
}
.el-carousel__item:nth-child(4n + 1) {
  width: 258px;
  background-image: url(/img/images/card_bg1.png);
  background-repeat: no-repeat;
  background-position: left top;
  border-radius: 10px;
}
.el-carousel__item:nth-child(4n + 2) {
  width: 258px;
  background-image: url(/img/images/card_bg2.png);
  background-repeat: no-repeat;
  background-position: left top;
  border-radius: 10px;
}
.el-carousel__item:nth-child(4n + 3) {
  width: 258px;
  background-image: url(/img/images/card_bg3.png);
  background-repeat: no-repeat;
  background-position: left top;
  border-radius: 10px;
}
.el-carousel__item:nth-child(4n + 4) {
  width: 258px;
  background-image: url(/img/images/card_bg4.png);
  background-repeat: no-repeat;
  background-position: left top;
  border-radius: 10px;
}
.el-carousel__indicators--outside {
  margin-top: 10px;
}
</style>
